/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringCriteriaResponse
 */
export interface StringCriteriaResponse {
    /**
     * 
     * @type {string}
     * @memberof StringCriteriaResponse
     */
    value?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StringCriteriaResponse
     */
    exclude?: boolean;
}

export function StringCriteriaResponseFromJSON(json: any): StringCriteriaResponse {
    return StringCriteriaResponseFromJSONTyped(json, false);
}

export function StringCriteriaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringCriteriaResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function StringCriteriaResponseToJSON(value?: StringCriteriaResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'exclude': value.exclude,
    };
}


